module.exports = __webpack_public_path__ + "static/gm-18-7d627bf1871d6cf773207e6d3fa035e3.jpg";